//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useRef } from 'react';
import styled from 'styled-components';

import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { useScriptLoaderQuery } from '@queries/useScriptLoaderQuery';
import {
  VIBE_WISTIA_JSONP_SCRIPT_ID,
  VIBE_WISTIA_JSONP_SCRIPT_URL,
  VIBE_WISTIA_PLAYER_SCRIPT_ID,
  VIBE_WISTIA_PLAYER_SCRIPT_URL,
  VIBE_WISTIA_SWATCH_URL,
  VIBE_WISTIA_VIDEO_ID,
} from '@welcome-page/constants/OnboardingConstants';

// TODO: PD-257587 - remove this component
export const VibeDemoVideo = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useScriptLoaderQuery(
    [
      QueryKeyConstants.WelcomeScreen,
      QueryKeyConstants.WelcomeScreenVibeWistiaJsonpScriptLoader,
    ],
    VIBE_WISTIA_JSONP_SCRIPT_ID,
    VIBE_WISTIA_JSONP_SCRIPT_URL,
  );

  useScriptLoaderQuery(
    [
      QueryKeyConstants.WelcomeScreen,
      QueryKeyConstants.WelcomeScreenVibeWistiaPlayerScriptLoader,
    ],
    VIBE_WISTIA_PLAYER_SCRIPT_ID,
    VIBE_WISTIA_PLAYER_SCRIPT_URL,
  );

  return (
    <RootContainer ref={containerRef}>
      <VideoContainer
        // Wistia embeded player options are provided as class names
        // https://docs.wistia.com/docs/embed-options-and-plugins
        className={`wistia_embed wistia_async_${VIBE_WISTIA_VIDEO_ID} seo=true videoFoam=false controlsVisibleOnLoad=false autoPlay=false playerColor=#3D4CBF`}
      >
        <SwatchContainer>
          <SwatchImage aria-hidden={true} />
        </SwatchContainer>
      </VideoContainer>
    </RootContainer>
  );
};

const RootContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 543px;
  height: 305px;
`;

const SwatchContainer = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  transition: opacity 200ms;
`;

const SwatchImage = styled.img.attrs({
  alt: '',
  src: VIBE_WISTIA_SWATCH_URL,
  onload: 'this.parentNode.style.opacity=1;',
})`
  width: 100%;
  height: 100%;
  filter: blur(5px);
  object-fit: contain;
`;
